/**
 * Dlaždica Scythe v knižnici portálu. Hra je zatiaľ len na polici (`planned`)
 * — engine ešte nie je, preto sa nedá spustiť. Obal je vlastná kresba (SVG),
 * nie art z krabice.
 */

import { GameCard } from '../../portal/GameCard.js';
import type { PortalTileProps } from '../registry.js';

export function ScytheTile(_props: PortalTileProps) {
  return (
    <GameCard
      title="Scythe"
      status="planned"
      titleStyle={{ fontFamily: "'Cinzel', Georgia, serif", fontWeight: 700, letterSpacing: '0.08em' }}
      players="1–5 hráčov"
      duration="1,5–2 h"
      tags={['Územie', 'Ekonomika', 'Mechy']}
      description="Alternatívna Európa po Veľkej vojne — rozvíjaj hospodárstvo, obsadzuj územie a stavaj mechy. Pripravujeme."
      cover={
        <span className="libCover libCover--scythe">
          <img className="libCover__img" src="/art/scythe/cover.webp" alt="Scythe" draggable={false} />
        </span>
      }
    />
  );
}
